import { Injectable, signal } from "@angular/core";

@Injectable({
	providedIn: "root"
})
export class EarnConsentScreenFacade {
	private viewModel = signal(null);
	public viewModel$ = this.viewModel.asReadonly();

	public setViewModel(assetId: string): void {
		this.viewModel.set(assetId);
	}
}
